// extracted by mini-css-extract-plugin
module.exports = {"Divider":"Divider_Divider__C0qid","SimpleDivider":"Divider_SimpleDivider__29GnD","Dashed":"Divider_Dashed__2DClw","DividerWithChildren":"Divider_DividerWithChildren__3w4zI"};